
import { RevLink } from '@ds/components/Link'
import { RevListItem } from '@ds/components/ListItem'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import FormattedMessage from '@i18n/components/FormattedMessage'

export default {
  components: {
    FormattedMessage,
    IconChevronRight,
    RevLink,
    RevListItem,
  },
  props: {
    answers: {
      type: Array,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
  },
}
